<template>
	<div id="app">
		<transition name="transition-anim">
			<router-view class="main-router"/>
		</transition>

		<transition-group name="transition-anim">
			<ConfirmModal key="0" v-if="modalName.indexOf('confirm-modal') > -1"/>
			<NotificationBanner key="1" v-if="notificationName.indexOf('notification-banner') > -1"/>
		</transition-group>
	</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
	computed: {
		...mapFields('modal', [
			'modalName',
			'notificationName'
        ]),
	},

	mounted () {
		// this.$store.dispatch('global/getCountryList')
		this.$store.dispatch('global/getPartnerCountryList')
		// this.$store.dispatch('global/getCompanyTypeList')
	},

	components: {
		ConfirmModal: () => import('@/components/utils/ConfirmModal'),
		NotificationBanner: () => import('@/components/utils/NotificationBanner')
	},
}
</script>

<style lang="scss">
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	position: relative;
	width: 100%;
	height: 100%;
    color: #778395;

	.main-router {
		overflow: hidden;
	}
}
</style>
